export const SUPPORT_ID = 'support';

export const SUPPORT_TICKET_RESOURCE = `${SUPPORT_ID}.ticket`;
export const SUPPORT_TICKET_COMMENT_RESOURCE = `${SUPPORT_ID}.ticket_comment`;
export const SUPPORT_NOTIFICATION_SETTING_RESOURCE = `${SUPPORT_ID}.notification_setting`;
export const SUPPORT_NOTIFICATION_RECIPIENT_RESOURCE = `${SUPPORT_ID}.notification_recipient`;
export const SUPPORT_NOTIFICATION_EVENT_RESOURCE = `${SUPPORT_ID}.notification_event`;

/**
 * Menu visibility as its own scope, per the UI scopes rollout
 * (`docs/features/ui-menu-visibility-scopes.md` in the API repo).
 *
 * Mirrors of the server-side `_SCOPES` constants, carrying only the scopes the
 * menu needs. Endpoint scopes are not repeated here — `GlobalScopes` and
 * `SupportScopes` cover those.
 */
export enum SUPPORT_TICKET_SCOPES {
  SideMenuItem = 'SideMenuItem',
}

export enum SUPPORT_NOTIFICATION_SETTING_SCOPES {
  SideMenuItem = 'SideMenuItem',
}
